import { http } from '../../../api'

const pages = {
  namespaced: true,
  state: {
    dataList: [],
    itemData: null
  },
  actions: {
    getAllData: ({ commit }, params) => {
      let url = '/page'
      if (params) {
        const q = new URLSearchParams(params)
        url = url + '?' + q.toString()
      }
      return http.get(url).then(res => {
        commit('setList', res.data.data)
        return res.data
      })
    },
    create: ({ commit }, params) => {
      return http.post('/page', params).then(res => {
        return res.data
      })
    },
    delete: ({ commit }, params) => {
      return http.delete('/page/' + params.id).then(res => {
        commit('setRemoveList', params.id)
      })
    },
    getData: ({ commit }, params) => {
      return http.get('/page/' + params.id).then(res => {
        commit('setData', res.data.data)
      })
    },
    update: ({ commit }, params) => {
      console.log(params.data)
      return http.put('/page/' + params.id, params.data).then(res => {
      })
    }
  },
  mutations: {
    setList (state, data) {
      state.dataList = data
    },
    setRemoveList (state, id) {
      state.dataList = state.dataList.filter(item => item.id !== id)
    },
    setData (state, data) {
      state.itemData = data
    }
  },
  getters: {
    dataList: state => state.dataList,
    itemData: state => state.itemData
  }
}

export default pages
